// Generated by ReScript, PLEASE EDIT WITH CARE

import * as List from "../../../../../../../node_modules/rescript/lib/es6/list.js";
import * as $$Array from "../../../../../../../node_modules/rescript/lib/es6/array.js";
import * as Js_string from "../../../../../../../node_modules/rescript/lib/es6/js_string.js";
import * as Caml_array from "../../../../../../../node_modules/rescript/lib/es6/caml_array.js";
import * as Config$PorterinUtils from "../../../../../../../node_modules/@porterin/utils/src/configs/Config.mjs";
import * as JsBindings$PorterinUtils from "../../../../../../../node_modules/@porterin/utils/src/bindings/common/JsBindings.mjs";
import * as OptionTypeUtils$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/utils/OptionTypeUtils.mjs";
import * as UtmUtils$PorterinFeature from "../utm-utils/UtmUtils.mjs";
import * as CookieStore$PorterinFeature from "./CookieStore.mjs";
import * as ExperimentsUtils$PorterinUtils from "../../../../../../../node_modules/@porterin/utils/src/experiments/ExperimentsUtils.mjs";

function getCookies(param) {
  var cookies = JsBindings$PorterinUtils.isBrowser(undefined) ? document.cookie : "";
  var cookiesLength = cookies.length;
  var ca = cookiesLength !== 0 ? $$Array.to_list(Js_string.split(";", Js_string.replaceByRe(/ /g, "", cookies))) : /* [] */0;
  return List.map((function (a) {
                var cookie = Js_string.splitByRe(/=(.+)/g, a);
                var match = cookie.length;
                if (match === 0 || match === 1) {
                  return {
                          key: OptionTypeUtils$Catalyst.getEmptyStringFrmOptionalType(Caml_array.get(cookie, 0)),
                          value: ""
                        };
                } else {
                  return {
                          key: OptionTypeUtils$Catalyst.getEmptyStringFrmOptionalType(Caml_array.get(cookie, 0)),
                          value: OptionTypeUtils$Catalyst.getEmptyStringFrmOptionalType(Caml_array.get(cookie, 1))
                        };
                }
              }), ca);
}

function getCookie(cookieName) {
  var cookies = getCookies(undefined);
  var cookie = List.exists((function (a) {
          return a.key === cookieName;
        }), cookies) ? List.find((function (a) {
            return a.key === cookieName;
          }), cookies) : undefined;
  if (cookie !== undefined) {
    return cookie.value;
  } else {
    return "";
  }
}

var setCookie = (function (cookie) {
  document.cookie=cookie
 });

function setCookieWithExpiration(key, value, daysToExpire) {
  var expiryTime = Math.imul(Math.imul(Math.imul(Math.imul(daysToExpire, 24), 60), 60), 1000) + Date.now();
  var expires = "expires=" + new Date(expiryTime).toUTCString();
  setCookie(key + "=" + value + ";" + expires + ";path=/");
}

var deleteCookie = (function (cookie) {
  document.cookie = cookie + "=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
});

function isWebTrackingIdInRange(lowerOpt, upper) {
  var lower = lowerOpt !== undefined ? lowerOpt : 0.0;
  var tracking_id = getCookie(CookieStore$PorterinFeature.web_tracking_id);
  return ExperimentsUtils$PorterinUtils.isIDMatched(tracking_id, upper, lower);
}

function getAuthCookies(param) {
  var web_tracking_id = getCookie(CookieStore$PorterinFeature.web_tracking_id);
  var auth_token = getCookie(CookieStore$PorterinFeature.auth_token);
  var mobile = getCookie(CookieStore$PorterinFeature.mobile);
  return [
          web_tracking_id,
          auth_token,
          mobile
        ];
}

function isDeliveryCkInRange(lowerOpt, upper) {
  var lower = lowerOpt !== undefined ? lowerOpt : 0.0;
  var tracking_id = getCookie(UtmUtils$PorterinFeature.delivery_ck);
  return ExperimentsUtils$PorterinUtils.isIDMatched(tracking_id, upper, lower);
}

function visitorIdentfierSafely(param) {
  var visitorIdCookie = getCookie(CookieStore$PorterinFeature.visitorId);
  var deliveryCookie = getCookie(CookieStore$PorterinFeature.deliveryCk);
  var visitorIdParts = visitorIdCookie === "" ? [] : Js_string.split("%3D", visitorIdCookie);
  var decryptedVisitorId = visitorIdParts.length === 2 ? Caml_array.get(visitorIdParts, 1) : "";
  if (deliveryCookie === "") {
    return decryptedVisitorId;
  } else {
    return deliveryCookie;
  }
}

function webTrackingIdSafely(param) {
  var webTrackingId = getCookie(CookieStore$PorterinFeature.web_tracking_id);
  if (webTrackingId === "") {
    return getCookie(CookieStore$PorterinFeature.visitorId);
  } else {
    return webTrackingId;
  }
}

export {
  getCookies ,
  getCookie ,
  setCookie ,
  setCookieWithExpiration ,
  deleteCookie ,
  isWebTrackingIdInRange ,
  getAuthCookies ,
  isDeliveryCkInRange ,
  visitorIdentfierSafely ,
  webTrackingIdSafely ,
}
/* Config-PorterinUtils Not a pure module */
